// extracted by mini-css-extract-plugin
export default {"container":"Checkout--container--hnDiK"};